// extracted by mini-css-extract-plugin
export default {"card":"groupCardStyle_card__rcCZc","active":"groupCardStyle_active__LKW8D"};